import { getCurRegion, getLocalInfo } from './multiRegionUtil';

export const REGION = getCurRegion();
export const LOWERCASE_REGION = getCurRegion().toLowerCase();
export const ALL_REGION = ['ID', 'MY', 'TH', 'PH', 'VN', 'SG', 'TW', 'BR', 'MX'];
export const IS_ID = getCurRegion() === 'ID'; // Indonesia
export const IS_MY = getCurRegion() === 'MY'; // Malaysia
export const IS_TH = getCurRegion() === 'TH'; // Thailand
export const IS_PH = getCurRegion() === 'PH'; // Philippines
export const IS_VN = getCurRegion() === 'VN'; // Vietnam
export const IS_SG = getCurRegion() === 'SG'; // Singapore
export const IS_TW = getCurRegion() === 'TW'; // 台湾
export const IS_BR = getCurRegion() === 'BR'; // 巴西
export const IS_MX = getCurRegion() === 'MX'; // 墨西哥

export const getRegionTimezone = () => getLocalInfo('timezone');
